// src/main.js
import { createApp } from 'vue';
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia';
import { useAuthStore } from './stores/authstore'
import '@vuepic/vue-datepicker/dist/main.css'

// Función de inicialización asíncrona
async function initializeApp() {
  const pinia = createPinia();
  const app = createApp(App);

  app.use(router);
  app.use(pinia);

  const authStore = useAuthStore(pinia);

  // --- LÓGICA DE AUTENTICACIÓN INICIAL ---  
  // La forma estándar de recibir un token de un tercero es a través de un parámetro en la URL.
  const urlParams = new URLSearchParams(window.location.search);
  const jwtData = urlParams.get('JWTData');

  if (jwtData) {
    // 1. Si se encuentra un token de puntos en la URL, se usa para autenticar.
    // Esto tiene la máxima prioridad y sobrescribirá cualquier sesión existente.
    try {
      // Enviamos el JWT completo al backend para su validación.
      await authStore.authenticate({ tokenPoints: jwtData });
      // Limpiamos la URL para que el token no quede visible ni se reutilice si el usuario recarga.
      window.history.replaceState({}, document.title, window.location.pathname);
    } catch (error) {
      console.error("Fallo la autenticación con el token de puntos, se procederá como invitado.");
      // Redirigimos a la página de error en caso de fallo en la autenticación.
      router.push({
        name: 'Error'
      });
    }
  }  else if (!authStore.isAuthenticated) {
    // 2. Si no hay token de puntos en la URL y no hay sesión previa, se solicita un token de invitado.
    await authStore.authenticate();
  }
  app.mount('#app')
}

initializeApp();